import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const metaTitleSuffix = " | ImprintCity";

export default new Router({
    mode: "history",
    scrollBehavior() {
        return {
            x: -2,
            y: -2
        };
    },
    routes: [
        //#### Fornt-end  route start ####
        {
            path: "/customer/reset-password/:token",
            name: "ResetPassword",
            component: () => import("@/views/ResetPassword")
            // meta: {
            //   notRequiredAuth: true
            // },
        },
        {
            path: "/",
            component: () => import("@/views/frontend/Home"),
            meta: { title: "Home" + metaTitleSuffix },
            children: [
                {
                    path: "",
                    name: "home",
                    component: () => import("@/views/frontend/Home"),
                    meta: { title: "Home" + metaTitleSuffix }
                }
            ]
        },
        {
            name: "company_store",
            path: "/company-store",
            component: () => import("@/views/frontend/company/CompanyStore")
        },
        {
            name: "create_company_store",
            path: "/create-company-store",
            component: () =>
                import("@/views/frontend/company/CreateCompanyStore")
        },
        {
            name: "created_company_store",
            path: "/created-company-store",
            component: () =>
                import("@/views/frontend/company/CreatedCompanyStore")
        },
        //credit new
        {
            name: "business_credit_app",
            path: "/business-credit",
            component: () =>
                import("@/views/frontend/business_credit/BusinessCreaditApp")
        },
        //credit new
        {
            name: "team_uniform",
            path: "/team-uniform",
            component: () =>
                import("@/views/frontend/business_credit/TeamUniform")
        },
        //colors view
        {
            name: "colors_view",
            path: "/standard-decoration-colors",
            component: () => import("@/views/frontend/ColorsView")
        },
        {
            name: "team_store",
            path: "/team/store",
            component: () => import("@/views/frontend/team/TeamStore")
        },
        {
            name: "create_team_store",
            path: "/team/create-team-store",
            component: () => import("@/views/frontend/team/CreateTeamStore")
        },
        {
            name: "design_team_store",
            path: "/team/design-team-store",
            component: () => import("@/views/frontend/team/Design")
        },
        {
            name: "custom_store",
            path: "/team/custom-store",
            component: () => import("@/views/frontend/team/CustomStore")
        },
        {
            name: "select_product",
            path: "/team/select-product",
            component: () => import("@/views/frontend/team/SelectProduct")
        },
        {
            name: "shipping",
            path: "/team/shipping",
            component: () => import("@/views/frontend/team/Shipping")
        },
        {
            name: "publish",
            path: "/team/publish",
            component: () => import("@/views/frontend/team/Publish")
        },
        {
            name: "created-team-store",
            path: "/team/created-team-store",
            component: () => import("@/views/frontend/team/CreatedTeamStore")
        },
        {
            name: "search",
            path: "/search",
            component: () => import("@/views/frontend/Search"),
            meta: { activeTab: "", pageTitle: "Search" }
        },
        {
            name: "product_list",
            path: "/product-list/:product_type/:category_id",
            component: () => import("@/views/frontend/ProductList"),
            meta: { activeTab: "", pageTitle: "Apparel" }
        },
        {
            name: "product_list_24_tshirt",
            path: "/product-list/:product_type",
            component: () => import("@/views/frontend/ProductList24TshirtV3"),
            meta: { activeTab: "", pageTitle: "Apparel" }
        },
        {
            name: "product_list_filter",
            path: "/product-list/:product_type/:category_id/:filter/:filter_text",
            component: () => import("@/views/frontend/ProductList"),
            meta: { activeTab: "", pageTitle: "Apparel" }
        },
        {
            name: "product_details",
            path: "/product-details/:id_of_product",
            component: () =>
                import("@/views/frontend/products/ProductDetailsV3"),
            meta: { activeTab: "", pageTitle: "Apparel" }
        },
        {
            name: "product_details_new",
            path: "/product-details-new/:id_of_product",
            component: () =>
                import("@/views/frontend/products/ProductDetailsV3New"),
            meta: { activeTab: "", pageTitle: "Apparel" }
        },

        {
            name: "product_details_preview",
            path: "/preview/product-details-new/:id_of_product",
            component: () =>
                import("@/views/frontend/products/ProductDetailsV3New"),
            meta: { activeTab: "", pageTitle: "Apparel" }
        },
        {
            name: "cartV3",
            path: "/cart/v3",
            component: () => import("@/views/frontend/cart_checkout/v3/Cart"),
            meta: {
                title: "Cart" + metaTitleSuffix
            }
        },
        {
            name: "reviewpay",
            path: "/reviewpay",
            component: () => import("@/views/frontend/ReviewPay")
        },
        {
            name: "checkoutV3",
            path: "/checkout/v3",
            component: () =>
                import("@/views/frontend/cart_checkout/v3/Checkout")
        },

        {
            name: "pendingPayment",
            path: "/pending_payment/:payment_pending_id",
            component: () =>
                import("@/views/frontend/cart_checkout/v3/PendingPayment")
        },

        
        {
            name: "AdditionalPayment",
            path: "/payment/:order_id",
            component: () => import("@/views/frontend/AdditionalPayment")
        },
        {
            name: "thankyou",
            path: "/thankyou",
            component: () => import("@/views/frontend/Thankyou")
        },
        {
            name: "thankyoupayment",
            path: "/thankyoupayment",
            component: () => import("@/views/frontend/ThankyouPayment")
        },
        {
            name: "EmailVerify",
            path: "/email-verification/:reset_token",
            component: () => import("@/views/frontend/EmailVerify")
        },
        //#### Front-end route end ###

        //####Footer Pages link start

        {
            name: "24hoursTShirts",
            path: "/24hourtshirts/:id_of_product",
            component: () =>
                import("@/views/frontend/products/ProductDetailsV3")
        },
        {
            name: "AboutUs",
            path: "/aboutus",
            component: () => import("@/views/frontend/footer_pages/AboutUs")
        },
        {
            name: "Brands",
            path: "/brands",
            component: () => import("@/views/frontend/footer_pages/Brands")
        },
        {
            name: "DecorationMethods",
            path: "/decoration",
            component: () =>
                import("@/views/frontend/footer_pages/DecorationMethods")
        },
        {
            name: "brand_products",
            path: "/brand/:brand_id",
            component: () =>
                import("@/views/frontend/products/BrandProductList"),
            meta: { activeTab: "", pageTitle: "Brand" }
        },
        {
            name: "DesignTemplates",
            path: "/design-templates",
            component: () =>
                import("@/views/frontend/footer_pages/DesignTemplates")
        },
        {
            name: "Embroidery",
            path: "/embroidery",
            component: () => import("@/views/frontend/footer_pages/Embroidery")
        },
        {
            name: "ICMarketingBlog",
            path: "/icmarketingblog",
            component: () =>
                import("@/views/frontend/footer_pages/ICMarketingBlog")
        },
        {
            name: "ScreenPrinting",
            path: "/screen-printing",
            component: () =>
                import("@/views/frontend/footer_pages/ScreenPrinting")
        },
        {
            name: "SiteMap",
            path: "/sitemap",
            component: () => import("@/views/frontend/footer_pages/SiteMap")
        },
        {
            name: "TermsConditions",
            path: "/term-and-condition",
            component: () =>
                import("@/views/frontend/footer_pages/TermsConditions")
        },
        {
            name: "PrivacyPolicy",
            path: "/privacy-policy",
            component: () =>
                import("@/views/frontend/footer_pages/PrivacyPolicy")
        },

        //####Footer Pages link end

        {
            name: "Account",
            path: "/account",
            component: () => import("@/views/frontend/MyAccount"),
            children: [
                {
                    name: "MyAccount",
                    path: "/myaccount",
                    component: () =>
                        import("@/views/frontend/account/MyAccount"),
                    meta: {
                        activeTab: "myaccount",
                        pageTitle: "My Account",
                        is_permission: "Saved Designs"
                    }
                },
                {
                    name: "EditProfile",
                    // path: "/editprofile",
                    path: "/edit-profile",

                    component: () =>
                        import("@/views/frontend/account/EditProfile"),
                    meta: {
                        activeTab: "editprofile",
                        is_permission: "Edit Profile",
                        authRequired: true
                    }
                },
                {
                    name: "MyAddresses",
                    path: "/my-addresses",

                    component: () =>
                        import("@/views/frontend/account/MyAddresses"),
                    meta: {
                        activeTab: "myaddresses",
                        is_permission: "My Addresses",
                        authRequired: true
                    }
                },
                {
                    name: "UploadImages",
                    path: "/upload-images",
                    component: () =>
                        import("@/views/frontend/account/UploadImages"),
                    meta: {
                        activeTab: "upload-images",
                        is_permission: "Uploaded Images"
                    }
                },
                {
                    name: "ManagePayment",
                    path: "/managepayment",
                    component: () =>
                        import("@/views/frontend/account/ManagePayment"),
                    meta: {
                        activeTab: "managepayment",
                        is_permission: "Payment Options",
                        authRequired: true
                    }
                },
                {
                    name: "Myorder",
                    path: "/myorder",
                    component: () => import("@/views/frontend/account/Myorder"),
                    meta: {
                        activeTab: "myorder",
                        title: "My Orders" + metaTitleSuffix,
                        is_permission: "My Orders",
                        authRequired: true
                    }
                },

                {
                    name: "Order_detail",
                    path: "/orderdetail/:id",
                    component: () =>
                        import("@/views/frontend/account/Order_detail"),
                    meta: { activeTab: "orderdetail", authRequired: true }
                },
                {
                    name: "ManagePlayer",
                    path: "/manageplayer",
                    component: () =>
                        import("@/views/frontend/account/ManagePlayer"),
                    meta: {
                        activeTab: "manageplayer",
                        is_permission: "Manage Player"
                    }
                },
                {
                    name: "MyStore",
                    path: "/mystore",
                    component: () => import("@/views/frontend/account/MyStore"),
                    meta: { activeTab: "mystore", is_permission: "My Store" }
                },
                {
                    name: "AddNewStore",
                    path: "/addnewstore",
                    component: () =>
                        import("@/views/frontend/account/AddNewStore"),
                    meta: { activeTab: "mystore" }
                },
                {
                    name: "ManageTeam",
                    path: "/manageteam",
                    component: () =>
                        import("@/views/frontend/account/ManageTeam"),
                    meta: {
                        activeTab: "manageteam",
                        is_permission: "Manage Team"
                    }
                },
                {
                    name: "Favorite",
                    path: "/favorite",
                    component: () =>
                        import("@/views/frontend/account/Favorite"),
                    meta: {
                        activeTab: "favorite",
                        is_permission: "Favorite",
                        authRequired: true
                    }
                },
                {
                    name: "CreateTeam",
                    path: "/createteam",
                    component: () =>
                        import("@/views/frontend/account/CreateTeam"),
                    meta: { activeTab: "createteam" }
                },
                {
                    name: "EditTeam",
                    path: "/team/:id",
                    component: () =>
                        import("@/views/frontend/account/CreateTeam"),
                    meta: { activeTab: "createteam" }
                },
                {
                    name: "TeamMember",
                    path: "/teammember/:id",
                    component: () =>
                        import("@/views/frontend/account/TeamMember"),
                    meta: { activeTab: "teammember" }
                },
                {
                    name: "AddNewPlayer",
                    path: "/addnewplayer",
                    component: () =>
                        import("@/views/frontend/account/AddNewPlayer"),
                    meta: { activeTab: "addnewplayer" }
                },
                {
                    name: "EditPlayer",
                    path: "/player/:id",
                    component: () =>
                        import("@/views/frontend/account/AddNewPlayer"),
                    meta: { activeTab: "addnewplayer" }
                },
                // here redirect page when the user have no access
                {
                    name: "AccessDenied",
                    path: "/no-access",
                    component: () => import("@/views/frontend/AccessDenied"),
                    meta: { activeTab: "AccessDenied" }
                }
            ]
        },

        {
            name: "OrderProofReview",
            path: "/orderproofreview/:id",
            component: () =>
                import("@/views/frontend/account/OrderProofReview"),
            meta: {
                activeTab: "orderproofreview",
                pageTitle: "My Account",
                is_permission: "My Orders"
            }
        },

        {
            name: "OrderProofView",
            path: "/orderproofview/:id",
            component: () => import("@/views/frontend/account/OrderProofView"),
            meta: {
                activeTab: "orderproofview",
                pageTitle: "My Account",
                is_permission: "My Orders"
            }
        },

        {
            name: "TeamMembers",
            path: "/teammember",
            component: () => import("@/views/frontend/account/TeamMember")
        },

        {
            name: "AddProduct",
            path: "/addproduct",
            component: () => import("@/views/frontend/account/AddProduct")
        },

        {
            name: "AddProductCatagory",
            path: "/addproductcatagory",
            component: () =>
                import("@/views/frontend/account/AddProductCatagory")
        },
        {
            name: "StoreDetails",
            path: "/storedetail",
            component: () => import("@/views/frontend/account/StoreDetails")
        },
        {
            name: "MyStoreDetail",
            path: "/mystoredetail",
            component: () => import("@/views/frontend/account/MyStoreDetail")
        },
        {
            name: "DesignStudioV3",
            path: "/design-studio/v3",
            component: () =>
                import("@/views/frontend/design_studio/V3/DesignStudioV3")
        },
        {
            name: "BuildListV3",
            path: "/design-studio/v3/build-list",
            meta: {
                authRequired: true,
                pageTitle: "Build List"
            },
            component: () =>
                import("@/views/frontend/design_studio/V3/BuildList")
        },
        {
            name: "BuildDetailsV3",
            path: "/design-studio/v3/build-details/:id",
            component: () =>
                import("@/views/frontend/design_studio/V3/BuildDetails"),
            meta: {
                authRequired: true,
                title: "Build Details"
            }
        },
        {
            name: "DesignStudioBuildV3",
            path: "/design-studio/v3/build",
            component: () =>
                import("@/views/frontend/design_studio/V3/DesignStudioBuildV3")
        },

        {
            name: "MyStoreOrderDetail",
            path: "/mystoreorderdetail",
            component: () =>
                import("@/views/frontend/account/MyStoreOrderDetail")
        },
        {
            name: "PromoDetails",
            path: "/promodetails",
            component: () => import("@/views/frontend/PromoDetails")
        },
        {
            name: "productnotfound",
            path: "/productnotfound",
            component: () => import("@/views/frontend/ProductNotFound")
        },
        {
            name: "404",
            path: "/404",
            component: () => import("@/views/frontend/404")
        },
        {
            path: "*",
            component: () => import("@/views/frontend/404")
        }
    ]
});
